/**
 * Component Registry for Parkplace Residential Theme
 * 
 * Extends the base landing-page theme registry with Parkplace Residential specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';
import { SpecialOffers } from './components/SpecialOffers';

/**
 * Parkplace Residential specific component overrides.
 * These components have been customized for the Parkplace Residential brand.
 */
const parkplaceresidentialOverrides: Partial<ComponentRegistry> = {
  SpecialOffers,
};

/**
 * Final merged registry for Parkplace Residential properties.
 * Inherits all components from the landing-page theme, with Parkplace Residential overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...parkplaceresidentialOverrides,
};

export default registry;
